<template lang="pug">
	section.section.main-section
		.container
			title-comp(:name="$t('alert.promo_code_is_correct', { 'code': userPromoCode })")
			.form-container.form-login
				.split-container
					p.subtitle.has-text-centered.no-line-break-mobile(style="margin-bottom: 1rem;")
						| {{ $t('profile.promo_code_access1') }}
					.has-text-centered
						button.button.is-primary.button-access(type="button" @click="goSignup")
							| {{ $t('menu.signup') }}

				.split-container.margin-top-md
					p.subtitle.has-text-centered
						| {{ $t('profile.promo_code_access_login1') + ' ' }}
						a(href="/privacy" @click="goLogin" style="text-decoration:underline;")
							| {{ $t('button.access_here') }}
						| {{ ' ' + $t('profile.promo_code_access_login2') }}

</template>

<script>
import TitleComponent from '../components/TitleComponent.vue'
import HourglassComponent from '../components/HourglassComponent.vue'
import { GiftIcon, XIcon } from 'vue-feather-icons'

export default {
	components: {
		TitleComp: TitleComponent,
		Hourglass: HourglassComponent,
		GiftIcon,
		XIcon
	},
	data() {
		return {
			promo_code      : '',
			openChoice      : false,
			submittedCode   : false,
			emptyPage       : false,
			loadingPromoCode: false,
			codeType        : null
		}
	},
	computed: {
		itLang() {
			return this.$t('locale.lang') === 'it'
		},
		language() {
			return this.$t('locale.lang')
		},
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		userPromoCode() {
			return this.$store.state.user.userPromoCode
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.promo_code") + ' | ' + this.$t("title.home") })
		if (this.accessToken) {
			this.$router.replace('/' + this.$route.params.language)
		}

		if (this.userPromoCode) {
			this.promo_code = this.userPromoCode
			this.openChoice = true
		} else {
			this.$router.replace('/' + this.$route.params.language + '/promo-code')
		}
	},
	methods: {
		goSignup() {
			this.$router.push('/' + this.$route.params.language + '/signup')
		},
		goLogin() {
			this.$router.push('/' + this.$route.params.language + '/login')
		}
	}
}
</script>
